import { AlertTriangle, ShieldAlert } from "lucide-react";
import Reveal from "./Reveal";
import { PROVIDER_GUIDE } from "@/config/clinicConfig";

export default function ProviderGuide() {
  return (
    <section id="choose" data-testid="provider-guide-section" className="pt-10 pb-10 lg:pt-14 lg:pb-16">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20 lg:px-8">
        <div>
          <Reveal>
            <h2 className="font-display text-3xl font-medium leading-snug tracking-tight text-espresso sm:text-4xl lg:text-[2.75rem]">
              {PROVIDER_GUIDE.heading}
            </h2>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="mt-10 rounded-3xl border border-gold/50 bg-[#F7F0DE] p-7">
              <p className="flex items-center gap-2.5 font-display text-lg font-semibold text-espresso">
                <AlertTriangle size={19} className="text-gold" />
                {PROVIDER_GUIDE.redFlags.title}
              </p>
              <ul className="mt-4 space-y-2.5">
                {PROVIDER_GUIDE.redFlags.items.map((r) => (
                  <li key={r} className="flex items-center gap-2.5 text-sm font-medium text-espresso/80">
                    <ShieldAlert size={15} className="shrink-0 text-clay" />
                    {r}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        <div>
          {PROVIDER_GUIDE.checklist.map((item, i) => (
            <Reveal key={item.q} delay={i * 0.06}>
              <div
                data-testid={`provider-checklist-item-${i + 1}`}
                className="group border-b border-espresso/10 py-6 transition-colors duration-300 first:border-t hover:bg-sand/60"
              >
                <div className="flex items-baseline gap-4 px-2">
                  <span className="font-mono text-sm text-gold">{String(i + 1).padStart(2, "0")}</span>
                  <div>
                    <h3 className="font-display text-lg font-semibold tracking-tight text-espresso transition-colors duration-300 group-hover:text-clay sm:text-xl">
                      {item.q}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-cocoa sm:text-[15px]">{item.a}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
